const intersectionHandler = entries => {
    entries.forEach(entry => { 
        entry.target.classList.toggle("is-pinned", entry.intersectionRatio < 1)
    })
}

const createObserver = stickyElement => {
    const stickyTop = parseInt(getComputedStyle(stickyElement).top) + 1;
    const observer = new IntersectionObserver(
        intersectionHandler,
        { 
            rootMargin: `-${stickyTop}px 0px 0px 0px`,
            threshold: 1
        }
    )

    observer.observe(stickyElement);
}

export default init = () => {
    const stickyElements = [...document.querySelectorAll('.jwc-sticky')];

    if (stickyElements.length === 0) return;

    stickyElements.forEach(element => createObserver(element));
}